export default "__VITE_ASSET__BGBQJtwV__"